import React from 'react'
import ReactGA from 'react-ga4'
import Yup from '../../../../helpers/custom-yup'
import Button from '../../../../components/buttons/buttons.component'
import MyOrder from './components/my-order.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component.jsx'
import Container from '../../../../components/layout/container.component'
import ShippingAddress from '../../../../components/form-components/shipping-address/shipping-address.component.jsx'
import AccordionSecondary from './../../../../components/accordion/accordion-secondary.component'
import * as config from 'config'
import { Formik } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { history } from './../../../../helpers/history'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions/toast.actions'
import { bindActionCreators } from 'redux'
import { StyledButtonContainer } from './components/styled-components.component'
import { paymentFieldsYupSchema } from '../../../../components/form-components/payment-fields/payment-fields.component.jsx'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import PaymentFields, {
	paymentFieldsInitialValues,
} from './../../../../components/form-components/payment-fields/payment-fields.component'
import { StoreProductService, TicketSaleService } from '../../../../services'

import Modal from '../../../../components/modal/modal.component'
import ReactHtmlParser from 'react-html-parser'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import { ToggleSwitch } from 'react-dragswitch'
import 'react-dragswitch/dist/index.css'
import './style.css'

const baseUrl = `${config.contentUrl}loja/produto/`

const quantityOptions = Array.from({ length: 5 }, (_, index) => ({
	label: index + 1,
	value: index + 1,
}))

const validationSchema = Yup.object().shape(paymentFieldsYupSchema)

class StoreProductRedeem extends React.Component {
	constructor(props) {
		super(props)
		this.redeem = redeem.bind(this)
		this.onClose = onClose.bind(this)
		this.debitCardModal = debitCardModal.bind(this)
		this.aceitarTermo = aceitarTermo.bind(this)
		this.updateQuantity = updateQuantity.bind(this)
		this.confirmRedemption = confirmRedemption.bind(this)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.paymentFormikRender = paymentFormikRender.bind(this)
		this.state = {
			isOpen: false,
			onClose: false,
			quantity: 1,
			imageUrl: '',
			productName: '',
			shouldRenderModalDebt: false,
			termoAceite: false,
		}
	}

	componentDidMount() {
		const { id } = this.props.match.params
		StoreProductService.getDetails(id).then(({ data }) => {
			const { name, productImages } = data
			const { source } = productImages.find(({ main }) => main)

			this.setState({
				productName: name,
				imageUrl: `${baseUrl}${source}`,
			})
		})
	}

	componentWillMount() {
		this.initialValues = {
			...paymentFieldsInitialValues({ installments: true }),
		}
	}

	render(...props) {
		const { shouldRenderModalDebt, modalDebitContent, isOpen, termoAceite } =
			this.state

		return (
			<Container medium>
				<AntiFraud />
				<AccordionSecondary
					arrow={false}
					multiple
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				<div className="checkAceite">
					<h1>Aceitar termos</h1>
					<p>
						Declaro que li e concordo com os{' '}
						<AnchorButton href="/regulamento" noStyle targetBlank>
							termos e condições de uso
						</AnchorButton>{' '}
						e com o{' '}
						<AnchorButton
							href="/politica-de-privacidade"
							noStyle
							targetBlank>
							termo de privacidade
						</AnchorButton>{' '}
						do programa Muviflex <span className="orange">*</span>
					</p>
					<label>
						<ToggleSwitch
							checked={termoAceite}
							onChange={(e) => {
								this.aceitarTermo(e)
							}}
							onColor={'#d4622f'}
						/>
						<strong>{termoAceite ? 'Sim' : 'Não'}</strong>
					</label>
				</div>

				<StyledButtonContainer>
					<Button primary type={'button'} onClick={this.confirmRedemption}>
						Confirmar Compra
					</Button>
				</StyledButtonContainer>
				{shouldRenderModalDebt ? (
					<Modal onClose={onClose} isOpen={isOpen}>
						{ReactHtmlParser(modalDebitContent)}
					</Modal>
				) : null}
			</Container>
		)
	}
}

function onClose() {
	this.setState({ isOpen: false })
	// clear form
	this.refs.form.resetForm()
}

function aceitarTermo(e) {
	let state = this.state
	if (e) {
		state.termoAceite = true
	} else {
		state.termoAceite = false
	}
	this.setState(state)
}

function redeem() {
	const {
		match,
		deviceId,
		toastError,
		hideLoading,
		showLoading,
		userMoveflexNumber,
	} = this.props
	const { id: productId } = match.params
	const { selectedPaymentCondition } = this.props.location.state
	const { productName, quantity, paymentMethod } = this.state

	const params = {
		deviceId,
		quantity,
		productId,
		paymentConditionId: selectedPaymentCondition.id,
		addressId: this.refs.address.getSelectedAddress().id,
		paymentMethod,
	}

	const { payment } = this.refs
	if (payment) {
		const paymentInfo = { ...payment.state.values }
		const { cardPrintedName } = paymentInfo
		paymentInfo.cardholderName = cardPrintedName
		delete paymentInfo.cardPrintedName

		params.paymentMethod = paymentInfo.paymentMethod
		delete paymentInfo.paymentMethod
		params.paymentInfo = paymentInfo

		if (params.paymentMethod === 'pixLoja') {
			params.paymentMethod = 'pix'
		}

		if (params.paymentMethod === 'pix') {
			paymentInfo.cardBrand = 'mastercard'
			paymentInfo.cardNumber = '0'
			paymentInfo.cardMonthValidity = '0'
			paymentInfo.cardYearValidity = '0'
			paymentInfo.cardholderName = '0'
			paymentInfo.installments = '1'
			paymentInfo.securityCode = '0'
		}
	}

	showLoading()

	StoreProductService.redeem(params)
		.then(({ errors, success, data }) => {
			hideLoading()
			if (success) {
				const id = `${userMoveflexNumber}x${+new Date()}`
				const { installments } = params.paymentInfo || { installments: 0 }
				ReactGA.event('purchase', {
					transaction_id: id,
					currency: 'BRL',
					value: selectedPaymentCondition.price * params.quantity,
					items: [
						{
							item_name: productName,
							item_id: '--',
							price: selectedPaymentCondition.price,
							quantity: params.quantity,
							item_category: 'Loja Muviflex',
							currency: 'BRL',
							points: selectedPaymentCondition.points,
							installments: installments || 0,
							payment_method: params.paymentMethod || '',
						},
					],
				})

				// if params have object debitcard
				if (paymentMethod === 'debitCard') {
					debitCardModal(data)
				}

				history.push(`${routes.CLIENTE}/loja/produto-resgatado`, data)
			} else
				toastError({
					message:
						(errors && errors.pop()) ||
						'Não foi possível comprar o produto',
				})
		})
		.catch((erro) => {
			console.log(erro)
		})
}

function debitCardModal(data) {
	if (data) {
		const { redirect_url, MD, PaReq, TermUrl } = data

		const obj = {
			MD,
			PaReq,
			TermUrl,
			redirectUrl: redirect_url,
		}

		TicketSaleService.sendGetNetDebitCard(obj)
			.then((response) => {
				if (response.success) {
					this.setState({
						modalDebitContent: response.data,
						shouldRenderModalDebt: true,
						isOpen: true,
					})
					hideLoading()
				}
			})
			.catch(console.error)
	}
}

function confirmRedemption() {
	const { toastError } = this.props

	let state = this.state

	if (!state.termoAceite) {
		toastWarning({
			message: 'Aceite os termos para prosseguir.',
		})
		return
	}

	const { payment } = this.refs

	if (payment) payment.submitForm()
	else this.redeem()
}

function paymentFormikRender(props) {
	const { selectedPaymentCondition } = this.props.location.state
	const { price } = selectedPaymentCondition

	return (
		<form noValidate onSubmit={props.handleSubmit}>
			<PaymentFields
				{...props}
				orderValue={price * this.state.quantity}
				noBankSlip
				noOnlineDebt
			/>
		</form>
	)
}

function updateQuantity(quantity) {
	this.setState({ quantity })
}

function getAccordionItems() {
	const { productName, imageUrl, quantity } = this.state
	const { id } = this.props.match.params
	const { selectedPaymentCondition } = this.props.location.state

	const sliceIndex = -Math.max(Math.log10(id), 4)
	const productCode = ('000' + id).slice(sliceIndex)
	const { points, price } = selectedPaymentCondition
	const totalPoints = (quantity * points).toLocaleString('pt-BR')
	const totalValue = quantity * price
	const hasPrice = price > 0

	const items = [
		{
			title: 'Meu pedido',
			initiallyOpened: true,
			content: (
				<MyOrder
					productName={productName}
					productCode={productCode}
					totalPoints={totalPoints}
					totalValue={totalValue}
					imageUrl={imageUrl}
				/>
			),
		},
		{
			title: 'Endereço de entrega',
			initiallyOpened: true,
			content: <ShippingAddress ref={'address'} />,
		},
	]

	if (hasPrice) {
		items.push({
			title: 'Forma de pagamento',
			initiallyOpened: true,
			content: (
				<Formik
					ref={'payment'}
					onSubmit={this.redeem}
					render={this.paymentFormikRender}
					initialValues={this.initialValues}
					validationSchema={validationSchema}
				/>
			),
		})
	}

	return items
}

const mapStateToProps = ({ antiFraud, user }) => ({
	deviceId: antiFraud.sessionID,
	userMoveflexNumber: user.moveflexNumber,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			toastError: toastActions.danger,
		},
		dispatch
	)

const connectedStoreProductRedeem = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(StoreProductRedeem)
)

export { connectedStoreProductRedeem as ModuleRootComponent }
